import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { installWebsiteAnalytics } from './services/websiteAnalytics';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInstagram, faFacebookF, faXTwitter, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faLock, faEnvelope, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'; // Added

library.add(faInstagram, faFacebookF, faXTwitter, faTiktok, faLock, faEnvelope, faBars, faTimes);

const app = createApp(App);
installWebsiteAnalytics(router);
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(router);
app.mount('#app');
